import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 14.97l-4.21-1.81-.79-.34-.79.34L7 17.97V5h10v12.97z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 17.97l4.21-1.81.79-.34.79.34L17 17.97V5H7z",
  opacity: ".3"
})), 'TurnedInTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TurnedInTwoTone.js
// module id = 6953
// module chunks = 2